import styled from 'styled-components';
import { color, radius, spacing } from 'theme';

export const StyledSubscribe = styled.div`
  background-color: ${color('emerald_100')};
  border: 2px solid ${color('emerald_500')};
  padding: ${spacing('md')};
  border-radius: ${radius('md')};
`;

export const StyledRadioInline = styled.div`
  display: flex;
  gap: ${spacing('md')};
`;
